/**
 * @file SKUブロックテンプレート
 */
'use strict';

let instance = null;

/**
 * @classname CartTemplate
 * @classdesc SKUブロックテンプレート
 */
export default class CartTemplate {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		if (instance) {
			return instance;
		}
		console.log('CartTemplate.constructor');
		instance = this;
		return instance;
	};
	/**
	 * カート商品
	 *
	 * @memberof CartTemplate
	 * @param {string} productId - 商品番号
	 * @param {string} skuId - SKU番号
	 * @param {string} skuName - SKU名
	 * @param {string} image - 画像パス
	 * @param {string} productName - 商品名
	 * @param {string} price - 価格
	 * @param {string} quantity - 数量
	 * @return {string} sku - SKUブロックのHTML
	 */
	static cartProduct (productId, skuId, skuName, image, productName, price, quantity) {
		console.log('CartTemplate.cartProduct');
		const viewPrice = `¥${parseInt(price).toLocaleString()}`;
		const product =
`<li class="list-item" data-product-id="${productId}" data-sku-id="${skuId}" data-price="${price}" data-quantity="${quantity}">
	<div class="block block-product">
		<div class="block block-product-image">
			<img src="${image}" alt="${productName}">
		</div>
		<div class="block block-product-info">
			<p class="text">${productName} (${skuName})</p>
			<p class="text text-cart-price">
				<strong>${viewPrice}</strong>（税込）</p>
		</div>
	</div>
	<div class="block block-sku-quantity">
		<p class="text text-quantity">数量　：<span>${quantity}</span></p>
	</div>
	<div class="block block-btn-box mt-4">
		<a class="btn btn-white btn-small remove-option" href="javascript:void(0);" data-product-id="${productId}" data-sku-id="${skuId}">選択を取り消す</a>
		<p class="text" style="font-size: 1.2rem;margin-top: 5px;">※ 数量を変更する場合は、一旦選択を取り消してから再度選択をしてください。</p>
	</div>
	<input type="hidden" name="feeProduct[${productId}][skuId]" value="${skuId}">
	<input type="hidden" name="feeProduct[${productId}][quantity]" value="${quantity}">
</li>`;
		return product;
	}
}
